export const getHost = (): string => {
  return typeof window !== 'undefined' ? window.location.hostname : ''
}

export const isLkmDomain = (): boolean => {
  const host = getHost()

  return (
    host.startsWith('lkm.') || // прод
    host.includes('.lkm-frontend') // дев
  )
}
